export interface TpaTrackingCookieValues {
    afid: string
    groupName: string
    cid: string
    parentId: string
}

export interface TpaBrandingCookieValues {
    afid: string
    groupName: string
    cid: string
}
export interface TpaBrandingFromCustomerProfile {
    branding: {
        value: string
        expires_in: string
    }
}

export interface AsiFlexCookieValues {
    asiFlexAvailableBalance: number | null
    asiFlexParticipantBalanceConsented: boolean
}

export interface CookieValuesType {
    tpaBranding: TpaBrandingCookieValues | null
    asiFlexData: AsiFlexCookieValues | null
}

export enum TpaGroupNames {
    TPA = 'tpa',
    BROKER = 'broker',
    PARENT = 'parent'
}

export enum TpaUrlParamIdentifiers {
    AFID = 'AFID',
    GROUP_NAME = 'GroupName',
    CID = 'CID',
    PARENT_ID = 'ParentID'
}
